/**
 * Helper utilities for extracting information from a dataset.
 */

/**
 * Find the object in `dataset.fields` that matches the specified `id`.
 */
export function findField(dataset, id, throwIfNotFound = true) {
  const foundField = dataset.fields.find(item => item.id === id);
  if (foundField) {
    return foundField;
  } else {
    if (throwIfNotFound) {
      throw new Error("Field \"" + id + "\" not found in dataset.");
    }
  }
  return undefined;
}

/**
 * Find the object in `dataset.variables` that matches the specified `id`.
 */
export function findVariable(dataset, id, throwIfNotFound = true) {
  const foundVariable = dataset.variables.find((item) => {
    return item.id === id;
  });
  if (foundVariable) {
    return foundVariable;
  } else {
    if (throwIfNotFound) {
      throw new Error("Variable \"" + id + "\" not found in dataset.");
    } else {
      return undefined;
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/utils/dataset-helper.js